module.exports = __webpack_public_path__ + "files/9c90ce7df6d964c4e5384446d14cdcd1.svg";